<template>
  <v-form v-model="valid" ref="DialogForm">
    <slotted-dialog :title="$t('servicesystem.common_objects.document.upload')" :externaltrigger="dialogtrigger"
      :externalCloseTrigger="closetrigger">

      <template v-slot:content>
        <v-container :key="dialogtrigger" class="pa-4" style="background-color: #f3f3f3;">
          <v-row no-gutters>
            <v-col>
              <drop-pad v-show="uploadFile == null" :outlined="true" :disabled="false" :multiple="multiple" :accept="accept"
                @fileDrop="handleFileDrop" @click="clickFileInput()">
              </drop-pad>
              <v-file-input v-show="uploadFile != null" v-model="uploadFile" :multiple="multiple" ref="fileinput"
                color="primary" :label="uploadFile != null ? 'File' : 'Click here to select file'"
                placeholder="Select file" prepend-icon="" outlined :show-size="1000" :accept="accept">
                <template v-if="!multiple || (uploadFile && uploadFile.length == 1)" v-slot:selection="{ text }">
                  <v-chip color="primary" dark label>
                    {{ text }}
                  </v-chip>
                </template>
              </v-file-input>
              <v-alert v-if="error" type="error" style="white-space: pre-line">
                {{ error }}
              </v-alert>
            </v-col>
          </v-row>
        </v-container>
      </template>

      <template v-slot:buttons>
        <v-btn color="close" outlined v-text="$t('servicesystem.common_objects.commonterms.cancel')"
          @click="closetrigger++">
        </v-btn>
        <v-btn :disabled="!saveable" :loading="loading" :color="'primary'" @click="saveable ? save() : null">
          {{ $t('servicesystem.common_objects.document.upload') }}
        </v-btn>
      </template>
    </slotted-dialog>
  </v-form>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import SlottedDialog from "@/views/layouts/SlottedDialog.vue";
import DropPad from "@/components/SingleUse/DropPad.vue";

export default {
  name: "UploadDialog3",
  props: {
    externaltrigger: Number,
    uploadFunc: Function,
    accept: String, //used as html accept prop on file inputs
    multiple: Boolean,
  },
  components: {
    SlottedDialog,
    DropPad,
  },
  mixins: [clientAPI],

  data() {
    return {
      dialogtrigger: 0,
      closetrigger: 0,
      valid: false,
      loading: false,
      clearKey: 1,
      uploadFile: null,
      error: null,
    };
  },

  methods: {
    SetDefaults() {
      this.valid = false;
      this.uploadFile = null;
      this.error = null;
    },

    clickFileInput() {
      const elem = this.$refs.fileinput.$refs.input;
      elem.click()
    },

    handleFileDrop(file) {
      if (this.multiple) {
        if (file && file.length != null && typeof file !== 'string') {
          // FileList or array-like
          this.uploadFile = Array.from(file);
        } else if (Array.isArray(file)) {
          this.uploadFile = file;
        } else if (file) {
          this.uploadFile = [file];
        } else {
          this.uploadFile = [];
        }
      } else {
        // single mode
        if (file && file.length != null && typeof file !== 'string') {
          // FileList or array-like
          this.uploadFile = file.length > 0 ? file[0] : null;
        } else if (Array.isArray(file)) {
          this.uploadFile = file.length > 0 ? file[0] : null;
        } else {
          this.uploadFile = file || null;
        }
      }
    },

    async save() {
      this.error = null;
      this.loading = true;
      await this.uploadFunc(this.uploadFile)
        .then(() => {
          this.closetrigger++;
        })
        .catch(error => {
          this.error = error;
        })
        .finally(() => {
          this.loading = false;
        })
    },
  },

  computed: {
    saveable() {
      if (this.loading || this.error || !this.valid) return false;
      if (this.multiple) {
        return Array.isArray(this.uploadFile) && this.uploadFile.length > 0;
      }
      return !!this.uploadFile;
    }
   },

  watch: {
    uploadFile: function () {
      this.error = null;
    },

    externaltrigger: function () {
      this.SetDefaults();
      this.dialogtrigger++;
    },
  },
};
</script>